import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid';

import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Totes_ShellService } from './Totes.shell.service';
import { Totes_OperationService } from './Totes.operation.service';
import { Totes_DatasourceService } from './Totes.datasource.index';
import { Totes_FlowService } from './Totes.flow.index';
import { Totes_FrontendFlowService } from './Totes.frontend.flow.service';
import { Totes_ReportService } from './Totes.report.index';
import { Totes_LocalizationService } from './Totes.localization.service';
import { Totes_tote_types_grid_ComponentContextService } from './Totes.tote_types_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './Totes.frontend.types'
import { $frontendTypes as $types} from './Totes.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface ITotes_tote_types_gridComponentEntity {
  Id?: number, ContainerTypeCategories?: number, Description?: string, Height?: number, Length?: number, Name?: string, VolumeCapacity?: number, Weight?: number, WeightCapacity?: number, Width?: number, VolumeUom?: { Name?: string, Short_name?: string }, WeightUom?: { Name?: string, Short_name?: string }, DimensionUom?: { Name?: string, Short_name?: string }}



class Totes_tote_types_gridComponentRowModel extends GridRowModel {
  grid: Totes_tote_types_gridComponent;
  entity: ITotes_tote_types_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
    volume_capacity_edit: new DatexFormControl(null, { validators: [  ], updateOn: 'change' }),
  });

  override cells = {
    Name: null,
    Description: null,
    Length: null,
    Width: null,
    Height: null,
    DimensionUom_Short_name: null,
    Weight: null,
    WeightCapacity: null,
    WeightUom_Short_name: null,
    VolumeUom_Short_name: null,
    volume_capacity: null,
  }



  constructor(
    grid: Totes_tote_types_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: Totes_ShellService,
private $datasources: Totes_DatasourceService,
private $flows: Totes_FlowService,
private $frontendFlows: Totes_FrontendFlowService,
private $reports: Totes_ReportService,
private $localization: Totes_LocalizationService,
private $operations: Totes_OperationService,
private $logger: CleanupLoggerService,
private $context: Totes_tote_types_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Description,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Length = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Length,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Width = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Width,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Height = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Height,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.DimensionUom_Short_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.DimensionUom_Short_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Weight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.WeightCapacity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.WeightCapacity,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.WeightUom_Short_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.WeightUom_Short_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.VolumeUom_Short_name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.VolumeUom_Short_name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.volume_capacity = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.volume_capacity,
      new TextModel(null, null, null, null, null)
,
      new NumberBoxModel(this.formGroup.controls['volume_capacity_edit'] as DatexFormControl, null, false, false, null, '', null)
      );
    
    
  }

  async $initializeExisting(entity: ITotes_tote_types_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.Id].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: ITotes_tote_types_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.Id].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.Id;
    const $inParams: { $keys: number[] } = {
      $keys:[$resultKey],
    };
    const $data = await this.$datasources.Totes.ds_container_types.getByKeys($inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);
      
    this.entity = $data.result[0] as ITotes_tote_types_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Name.displayControl as TextModel).text = $row.entity.Name;
    (this.cells.Description.displayControl as TextModel).text = $row.entity.Description;
    (this.cells.Length.displayControl as TextModel).text = $row.entity.Length?.toString();
    (this.cells.Width.displayControl as TextModel).text = $row.entity.Width?.toString();
    (this.cells.Height.displayControl as TextModel).text = $row.entity.Height?.toString();
    (this.cells.DimensionUom_Short_name.displayControl as TextModel).text = $row.entity.DimensionUom?.Short_name;
    (this.cells.Weight.displayControl as TextModel).text = $row.entity.Weight?.toString();
    (this.cells.WeightCapacity.displayControl as TextModel).text = $row.entity.WeightCapacity?.toString();
    (this.cells.WeightUom_Short_name.displayControl as TextModel).text = $row.entity.WeightUom?.Short_name;
    (this.cells.VolumeUom_Short_name.displayControl as TextModel).text = $row.entity.VolumeUom?.Short_name;
    (this.cells.volume_capacity.displayControl as TextModel).text = $row.entity.VolumeCapacity.toString();
    (this.cells.volume_capacity.editControl as NumberBoxModel).reset($row.entity.VolumeCapacity);

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
      this.isNew = false;
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }


}


@Component({
  imports: [
    SharedModule,
  ],
  selector: 'Totes-tote_types_grid',
  templateUrl: './Totes.tote_types_grid.component.html'
})
export class Totes_tote_types_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: ITotes_tote_types_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;

canEdit: boolean = true;
// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
canAdd: boolean = true; 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);

  fullTextSearch: string;



  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Name: new GridHeaderModel(new HeaderStyles(null, null), 'Name', 'Name', false, false, null, false),       Description: new GridHeaderModel(new HeaderStyles(null, null), 'Description', 'Description', false, false, null, false),       Length: new GridHeaderModel(new HeaderStyles(null, null), 'Length', 'Length', false, false, null, false),       Width: new GridHeaderModel(new HeaderStyles(null, null), 'Width', 'Width', false, false, null, false),       Height: new GridHeaderModel(new HeaderStyles(null, null), 'Height', 'Height', false, false, null, false),       DimensionUom_Short_name: new GridHeaderModel(new HeaderStyles(null, null), 'DimensionUom_Short_name', 'Dimension uom', false, false, null, false),       Weight: new GridHeaderModel(new HeaderStyles(null, null), 'Weight', 'Weight', false, false, null, false),       WeightCapacity: new GridHeaderModel(new HeaderStyles(null, null), 'WeightCapacity', 'Weight capacity', false, false, null, false),       WeightUom_Short_name: new GridHeaderModel(new HeaderStyles(null, null), 'WeightUom_Short_name', 'Weight uom', false, false, null, false),       VolumeUom_Short_name: new GridHeaderModel(new HeaderStyles(null, null), 'VolumeUom_Short_name', 'Volume uom', false, false, null, false),       volume_capacity: new GridHeaderModel(new HeaderStyles(null, null), 'volume_capacity', 'Volume capacity', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: Totes_tote_types_gridComponentRowModel[] = [];


  topToolbar = {
  };

  bottomToolbar = {
    addLine : new ToolModel(new ButtonModel(null, null, false, false, false, 'Add row', 'icon-ic_fluent_add_circle_20_regular')),
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: Totes_ShellService,
    private $datasources: Totes_DatasourceService,
    private $flows: Totes_FlowService,
    private $frontendFlows: Totes_FrontendFlowService,
    private $reports: Totes_ReportService,
    private $localization: Totes_LocalizationService,
    private $operations: Totes_OperationService,
    private $logger: CleanupLoggerService,
    private $context: Totes_tote_types_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Tote types';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 25;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const $inParams: { $top?: number, $skip?: number } = {
      $top: this.pageSize,
      $skip: this.pageSkip,
    };
    try {
      const $data = await this.$datasources.Totes.ds_container_types.getList($inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);

      this.entities = $data.result as ITotes_tote_types_gridComponentEntity[];
      this.totalCount = $data.totalCount;

      await this.$dataLoaded();
      
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new Totes_tote_types_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$frontendFlows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns($inParams: any, $outParams: any) {
      const $datasource = { inParams: $inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: Totes_tote_types_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  async addRow(entity?: ITotes_tote_types_gridComponentEntity) {
    const row = new Totes_tote_types_gridComponentRowModel(
      this,
      this.$utils,
      this.$settings,
      this.$shell, 
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$localization,
      this.$operations,
      this.$logger,
      this.$context);
    await row.$initializeNew(entity);
    this.rows.push(row);
    row.setEditMode();
    return row;
  }
  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
